var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hover-full"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.temp.title)}}),_vm._v(" "),_c('ul',_vm._l((_vm.temp.content),function(node){return _c('li',[_c('h4',{domProps:{"innerHTML":_vm._s(node.sub)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(node.body)}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ed9b0e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hover/Full.vue
// module id = 397
// module chunks = 1